import { gql, useMutation } from '@apollo/client'

export interface UpdateSettingsMutation {
  updated: {
    isOk: boolean
  }
}
export interface UpdateSettingsMutationVariables {
  settings: string
}

export const GQL_MUTATION_UPDATE_SETTINGS = gql`
  mutation ($settings: String!) {
    updated: updateSettings(settings: $settings) {
      isOk
    }
  }
`

export function useMutateUpdateSettings () {
  return useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(
    GQL_MUTATION_UPDATE_SETTINGS
  )
}
